import { useState } from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import './App.css'
import BirthDetailsPage from './components/BirthDetailsPage'
import BirthLocationPage from './components/BirthLocationPage'
import DashboardPage from './components/DashboardPage' // Новый компонент
import EditProfilePage from './components/EditProfilePage' // Новый компонент
import FullReportPage from './components/FullReportPage' // Компонент полного отчета
import Header from './components/Header' // Импортируем компонент Header
import IPRChecklistPage from './components/IPRChecklistPage' // Компонент страницы чек-листа
import LoginPage from './components/LoginPage'
import PersonalInfoPage from './components/PersonalInfoPage'
import ProfilePage from './components/ProfilePage'
import ProtectedRoute from './components/ProtectedRoute'
import QuestionnairePage from './components/QuestionnairePage'
import ResetPasswordPage from './components/ResetPasswordPage'
import ResultsPage from './components/ResultsPage'
import SetNewPasswordPage from './components/SetNewPasswordPage'
import VerifyOtpPage from './components/VerifyOtpPage'
import useCurrentUser from './hooks/useCurrentUser'

// Используем порт 5001 для API
import { supabase } from './supabase/client'

function App() {
  const { user: currentUser, loading } = useCurrentUser()
  const [userData, setUserData] = useState({
    personalInfo: {},
    birthDetails: {},
    birthLocation: {},
    talentIndices: [],
    talents: [],
    talentResponses: [],
    talentLevels: [],
    satisfactionLevels: [],
  })

  if (loading) {
    return <div>Loading...</div> // Handle loading state while user is being fetched
  }

  const handleLogin = (isDemo = false) => {
    // Генерируем userId для демо-режима или используем реальный ID после авторизации
    const newUserId = isDemo ? `demo-${Date.now()}` : `user-${Date.now()}`
    // Сохраняем userId в localStorage для использования в компонентах
    localStorage.setItem('currentUserId', newUserId)
  }

  const updateUserData = (category: string, data: any) => {
    setUserData((prevData) => ({
      ...prevData,
      [category]: data,
    }))
    console.log(`Обновлены данные '${category}'`)
  }

  const fetchTalentIndices = async (birthData: object) => {
    try {
      console.log('Отправка запроса на расчет талантов:', birthData)

      const response = await supabase.functions.invoke('evo-profile-ipr', {
        body: birthData,
      })

      if (response.error) {
        throw new Error(response.error.message || `Error server: ${response.error.status}`)
      }
      const data = response.data

      console.log('Получен ответ от сервера:', data)

      // Обновляем данные о талантах
      updateUserData('talentIndices', data.talentIds)
      updateUserData('talents', data.talents)

      return data.talentIds
    } catch (error) {
      console.error('Ошибка при получении талантов:', error)
      throw error
    }
  }

  return (
    <Router>
      <Header user={currentUser} />
      <div className="app">
        <Routes>
          <Route
            path="/login"
            element={
              currentUser ? <Navigate to="/dashboard" /> : <LoginPage onLogin={handleLogin} />
            }
          />
          <Route
            path="/reset-password"
            element={currentUser ? <Navigate to="/dashboard" /> : <ResetPasswordPage />}
          />
          <Route path="/set-new-password" element={<SetNewPasswordPage />} />
          <Route
            path="/"
            element={
              currentUser ? <Navigate to="/dashboard" /> : <LoginPage onLogin={handleLogin} />
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage userId={currentUser?.id} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/personal-info"
            element={
              <ProtectedRoute>
                <PersonalInfoPage updateUserData={updateUserData} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/birth-details"
            element={
              <ProtectedRoute>
                <BirthDetailsPage updateUserData={updateUserData} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/birth-location"
            element={
              <ProtectedRoute>
                <BirthLocationPage
                  updateUserData={updateUserData}
                  fetchTalentIndices={fetchTalentIndices}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/questionnaire"
            element={
              <ProtectedRoute>
                <QuestionnairePage
                  talentIndices={userData.talentIndices}
                  talents={userData.talents}
                  updateUserData={updateUserData}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/results"
            element={
              <ProtectedRoute>
                <ResultsPage userData={userData} userId={currentUser?.id} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/:userId"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-profile/:profileId"
            element={
              <ProtectedRoute>
                <EditProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/full-report/:userId"
            element={
              <ProtectedRoute>
                <FullReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checklist/:userId/:talentId"
            element={
              <ProtectedRoute>
                <IPRChecklistPage />
              </ProtectedRoute>
            }
          />
          <Route path="/verify-otp" element={<VerifyOtpPage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
